import { getMockExamListApi } from "@/api/services/admin/learning-content";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching the list of mock exams for an industry.
 */
export const useMockExamList = (industryId?: string) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_MOCK_EXAM_LIST, industryId],
    queryFn: () => getMockExamListApi(industryId!),
    enabled: Boolean(industryId),
  });

  return {
    data: query.data?.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
